import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.95472 3.09091H13.4547C13.8646 3.09091 14.2577 3.25373 14.5475 3.54356C14.8374 3.83339 15.0002 4.22648 15.0002 4.63636V15.4545C15.0002 15.8644 14.8374 16.2575 14.5475 16.5473C14.2577 16.8372 13.8646 17 13.4547 17H4.95472C4.54484 17 4.15175 16.8372 3.86192 16.5473C3.57209 16.2575 3.40927 15.8644 3.40927 15.4545V4.63636C3.40927 4.22648 3.57209 3.83339 3.86192 3.54356C4.15175 3.25373 4.54484 3.09091 4.95472 3.09091ZM1.86381 0H11.1365V1.54545H1.86381V12.3636H0.318359V1.54545C0.318359 1.13557 0.481184 0.742482 0.771012 0.452653C1.06084 0.162824 1.45393 0 1.86381 0Z"
      fill="#222A5C"
    />
  </svg>,
  "Copy"
);
